import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { RestService } from "../../../services/rest/rest.service";
import { CommonService } from "../../../services/common/common.service";
import { HelpIndex, Endpoint, ReviewSystem } from "../../../models/enums";
import { BaseModalComponent } from "../../../models/base-modal-component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AlignDirection, CellTemplateType, FilterTemplateType, GenericColDef, GridContext, GridRowSelectionType, SortByFilter } from "../../../models/grid-context";
import { AuditLog } from "../../../models/audit-log";
import { GenericGridComponent } from "../../generic-grid/generic-grid.component";
import * as _ from 'lodash';
import { SelectionChangedEvent } from "ag-grid-community";

@Component({
    standalone: false,
    selector: "res-select-review-template-modal",
    templateUrl: "./select-review-template-modal.component.html",
    styleUrls: ["./select-review-template-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class SelectReviewTemplateModalComponent
    extends BaseModalComponent
    implements AfterViewInit {
    @ViewChild(GenericGridComponent, { static: true })
    genericGrid: GenericGridComponent;

    modalTitle = "Select Review Template";
    secondaryButtonLabel = "Cancel";
    primaryButtonLabel = 'OK';
    maximizable: false;
    modalHelpIndex = HelpIndex.create_case_select_review_template_dlg;
    modalAutomationId = "select-review-template";
    modalClass = "select-review-template-modal";
    gridName = "SelectReviewTemplate";
    isBusy = false;
    isBusyMessage = "Loading...";
    originalItems = [];
    availableReviewTemplates = [];


    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService
    ) {
        super(modalService, modalRef);
    }
    rowSelection = GridRowSelectionType.singleCheckboxWithRowClickSelection;
    columnDefs = new Array<GenericColDef>(
        {
            headerName: "Project Name",
            field: "name",
            automationId: this.modalAutomationId,
            defaultSortBy: SortByFilter.NAME,
            filterType: FilterTemplateType.comboBox,
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            lockVisible: true,
            reviewIcon: true,

        },
        {
            headerName: "Project ID",
            field: "id",
            automationId: this.modalAutomationId,
            width: 100,
            lockVisible: true,
        },
        {
            headerName: "Date Created",
            field: "createDate",
            valueGetter: (params: any) => {
                const dataParts = params.data.createDate.replace('Z[UTC]', '').replace('T', ' ').split('.');
                if (dataParts.length > 0) {
                    return dataParts[0];
                }
            },
            cellAlignDirection: AlignDirection.right,
            headerAlignDirection: AlignDirection.right,
            automationId: this.modalAutomationId,
            lockVisible: true,
            width: 140,
        },
        {
            headerName: "Billing Status",
            field: "billingStatus",
            automationId: this.modalAutomationId,
            width: 160,
            lockVisible: true,
        },
    );

    gridContext = new GridContext({
        inlineGridFilter: true,
        sortTypeEnabled: false,
        sortEnabled: false,
        sortAscending: true,
        sortBy: SortByFilter.NAME,
        sortByFieldName: 'sortByFilter',
        onFilterApply: (queryStr, filterType, headerName) => this.onFilterApply(queryStr, filterType, headerName),
    });

    ngAfterViewInit() {
        this.modalData.availableReviewTemplates.forEach(item => {
            item.name = item.template.name;
            item.id = item.template.id;
        })
        this.originalItems = _.clone(this.modalData.availableReviewTemplates);
        const projectNameColDef = this.columnDefs.find(f => f.field === 'name');
        if (projectNameColDef) {
            projectNameColDef.filterItems = this.modalData.availableReviewTemplates.map(item => item.name);
        }
        this.setData(this.modalData.availableReviewTemplates, true);
    }

    setData(items, firstLoad = false) {
        if (this.genericGrid) {
            const selectedRows = this.genericGrid.selectedRows;
            this.genericGrid.setData(items);
            setTimeout(() => {
                if (firstLoad) {
                    const node = this.genericGrid.getRows().find(row => row.data.name === this.modalData.selectedTemplate);
                    if (node) {
                        this.genericGrid.selectNode(node);
                    }
                } else {
                    selectedRows.forEach(selectedRow => {
                        const node = this.genericGrid.getRows().find(row => row.data.id === selectedRow.id);
                        if (node) {
                            this.genericGrid.selectNode(node);
                        }
                    })
                }
            });
        }
    }

    onFilterApply(queryStr, filterType, headerName) {
        this.genericGrid.onFilterApply(queryStr, filterType, headerName);
        if (this.genericGrid.filters?.length > 0) {
            var filteredItems = _.cloneDeep(this.originalItems);
            this.genericGrid.filters.forEach(filter => {
                filteredItems = _.filter(filteredItems, (item) => item.template.name ? item.template.name.toLowerCase().indexOf(filter.value.toLowerCase()) !== -1 : false);
            })
            this.setData(filteredItems);
        } else {
            this.setData(this.originalItems);
        }
    }

    close() {
        this.closeModal(true);
    }

    ok() {
        this.closeModal(true, this.genericGrid.selectedRows);
    }

    isPrimaryButtonEnabled() {
        return this.genericGrid.selectedRows?.length > 0;
    }
}
